import { TRANSLATIONS_JP_SHELL_AND_COMMON } from "./translations.jp.shell-and-common";
import { TRANSLATIONS_JP_SETTINGS_CORE } from "./translations.jp.settings-core";
import { TRANSLATIONS_JP_SETTINGS_GOOGLE } from "./translations.jp.settings-google";
import { TRANSLATIONS_JP_SETTINGS_MICROSOFT } from "./translations.jp.settings-microsoft";
import { TRANSLATIONS_JP_DOCUMENTS_AND_DRIVE } from "./translations.jp.documents-and-drive";
import { TRANSLATIONS_JP_CHAT_TASKS_AND_PROFILE } from "./translations.jp.chat-tasks-and-profile";
import { TRANSLATIONS_JP_DASHBOARD_AND_KNOWLEDGE } from "./translations.jp.dashboard-and-knowledge";
import { TRANSLATIONS_JP_PLANS_AND_ADMIN } from "./translations.jp.plans-and-admin";
import { TRANSLATIONS_JP_ONBOARDING } from "./translations.jp.onboarding";
import { TRANSLATIONS_JP_GENERATION } from "./translations.jp.generation";
import { TRANSLATIONS_JP_HOME_ACTIONS_AND_OVERVIEW } from "./translations.jp.home-actions-and-overview";
import { TRANSLATIONS_JP_HOME_DECISION_DETAIL } from "./translations.jp.home-decision-detail";
import { TRANSLATIONS_JP_HOME_QUEUE_AND_ACTIVITY } from "./translations.jp.home-queue-and-activity";
import { TRANSLATIONS_JP_HOME_PULSE_AND_CALENDAR } from "./translations.jp.home-pulse-and-calendar";
import { TRANSLATIONS_JP_HOME_QUALITY_AND_ALERTS } from "./translations.jp.home-quality-and-alerts";

export const TRANSLATIONS_JA = {
  ...TRANSLATIONS_JP_SHELL_AND_COMMON,
  ...TRANSLATIONS_JP_SETTINGS_CORE,
  ...TRANSLATIONS_JP_SETTINGS_GOOGLE,
  ...TRANSLATIONS_JP_SETTINGS_MICROSOFT,
  ...TRANSLATIONS_JP_DOCUMENTS_AND_DRIVE,
  ...TRANSLATIONS_JP_CHAT_TASKS_AND_PROFILE,
  ...TRANSLATIONS_JP_DASHBOARD_AND_KNOWLEDGE,
  ...TRANSLATIONS_JP_PLANS_AND_ADMIN,
  ...TRANSLATIONS_JP_ONBOARDING,
  ...TRANSLATIONS_JP_GENERATION,
  ...TRANSLATIONS_JP_HOME_ACTIONS_AND_OVERVIEW,
  ...TRANSLATIONS_JP_HOME_DECISION_DETAIL,
  ...TRANSLATIONS_JP_HOME_QUEUE_AND_ACTIVITY,
  ...TRANSLATIONS_JP_HOME_PULSE_AND_CALENDAR,
  ...TRANSLATIONS_JP_HOME_QUALITY_AND_ALERTS,
};
